import Avatar from '@mui/material/Avatar';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import axios from 'axios';
import i18next from 'i18next';
import moment from 'moment';
import 'moment/locale/vi';
import {
  Fragment,
  memo,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  apiNotificationUrl,
  NotificationTypeImageEnum,
  NotificationTypeLinkEnum,
} from '../constants';
import { AuthContext } from '../contexts/AuthContext';
import { NotificationContext } from '../contexts/NotificationContext';
moment.locale('vi');

const Notifications = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const {
    authState: { user, isAuthenticated, authLoading },
    loadUser,
  } = useContext(AuthContext);
  const {
    notificationState: { notification, notificationLoading, pagination },
    getNotification,
  } = useContext(NotificationContext);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [flag, setFlag] = useState(0);
  const userId = useMemo(() => user?.id, [user?.id]);

  if (!authLoading && !isAuthenticated) {
    navigate(`/login?RedirectTo=${location.pathname}${location.search}`);
  }

  useEffect(() => {
    async function init() {
      if (userId) {
        if (notification.length < 10) {
          await getNotification(userId, 10, 1);
        }
        if (user.totalUnreadNotification !== 0 && flag === 0) {
          await axios.put(
            `${apiNotificationUrl}/notifications/mark-seen/${userId}`
          );
          setFlag(1);
          await loadUser();
        }
      }
    }
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  i18next.on('languageChanged', function (lng) {
    if (lng === 'en') moment.locale('en');
    else moment.locale('vi');
  });
  useEffect(() => {
    if (i18next.resolvedLanguage === 'en') moment.locale('en');
    else moment.locale('vi');
  }, []);

  const loadMoreData = useCallback(async () => {
    if (loading) {
      return;
    }
    setLoading(true);
    await getNotification(userId, 10, page + 1);
    setLoading(false);
    setPage(page + 1);
  }, [getNotification, loading, page, userId]);

  if (notificationLoading) {
    return (
      <div
        style={{
          left: '50%',
          top: '50%',
          transform: 'translateY(-50%)',
          position: 'absolute',
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      {/* <!-- Breadcrumb Section Begin --> */}
      <section
        className="breadcrumb-section set-bg"
        style={{
          backgroundImage: `url(img/breadcrumb.jpg)`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="breadcrumb__text">
                <h2>{t('notifications.title')}</h2>
                <div className="breadcrumb__option">
                  <Link to="/">{t('header.home')}</Link>
                  <span>{t('notifications.title')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Breadcrumb Section End --> */}
      <section style={{ paddingTop: '20px', paddingBottom: '40px' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-2"></div>
            <div
              className="col-lg-8"
              style={{
                padding: '20px 16px',
                backgroundColor: '#f5f5f5',
                borderRadius: '10px',
              }}
            >
              <InfiniteScroll
                dataLength={notification.length}
                next={loadMoreData}
                hasMore={pagination.totalItems < notification.length}
                loader={
                  <Skeleton
                    animation="wave"
                    variant="rounded"
                    width={210}
                    height={60}
                  />
                }
                scrollableTarget="scrollableDiv"
              >
                {notification?.map((item) => (
                  <Link
                    to={
                      item.type === 'REPLY_COMMENT'
                        ? `/products/${item.title
                            ?.replace(/\s/g, '-')
                            ?.toLowerCase()
                            ?.normalize('NFD')
                            ?.replace(/[\u0300-\u036f]/g, '')}`
                        : NotificationTypeLinkEnum[item.type]
                    }
                    key={item.id}
                  >
                    <ListItem alignItems="flex-start">
                      <ListItemAvatar>
                        <Avatar
                          alt={item.type}
                          src={NotificationTypeImageEnum[item.type]}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.title}
                        secondary={
                          <Fragment>
                            {`${moment(
                              item.createdAt ?? '2001-01-21'
                            ).fromNow()} - `}
                            <Typography
                              sx={{ display: 'inline' }}
                              component="span"
                              variant="body2"
                              color="text.primary"
                            >
                              {item.description}
                            </Typography>
                          </Fragment>
                        }
                      />
                    </ListItem>
                    <Divider
                      variant="inset"
                      component="li"
                      sx={{ listStyleType: 'none' }}
                    />
                  </Link>
                ))}
              </InfiniteScroll>
            </div>
            <div className="col-lg-2"></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default memo(Notifications);
